import React from "react";

function Dashboard() {
  return (
    <div style={{ padding: 20, overflowX: "auto", minHeight: "100%" }}>
      <h2 style={{ textAlign: "center", marginBottom: 20, fontFamily: "Arial, sans-serif" }}>
        Introduction to Social Accounting Matrix (SAM)
      </h2>
      <div style={{ maxWidth: "800px", margin: "0 auto", lineHeight: "1.6" }}>
        <p>
          A Social Accounting Matrix (SAM) is a comprehensive, economy-wide data framework
          representing the flow of all economic transactions that take place within an economy
          over a certain period of time.
        </p>
        <p>
          It includes detailed information about the income and expenditure of different
          institutions such as households, government, enterprises, and the rest of the world.
          SAMs are useful for economic modeling, including Computable General Equilibrium (CGE)
          analysis, and help in understanding how different sectors of the economy are
          interlinked.
        </p>
        <p>
          In this application, you can interact with the SAM through the Spreadsheet tab and
          explore its structure and implications through dashboards and visualizations.
        </p>
      </div>
    </div>
  );
}

export default Dashboard;
